<template>
  <div>
    <NarrowContainer
      :canGoBack="true"
    >
      <MyScheduledPayments />
    </NarrowContainer>
  </div>
</template>

<script>
import MyScheduledPayments from '@/modules/myProfile/components/MyScheduledPayments.vue';
import NarrowContainer from '@/layouts/NarrowContainer.vue';

export default {
  name: 'ScheduledPayments',

  components: {
    MyScheduledPayments,
    NarrowContainer
  },

  data () {
    return {
    };
  }
};
</script>

<style lang="less">

</style>
